import { render, staticRenderFns } from "./price-input.vue?vue&type=template&id=164e0fce&"
import script from "./price-input.vue?vue&type=script&lang=ts&"
export * from "./price-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports